import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, EMPTY, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { SessionFacade } from '../facades/session.facade';
import { AppError } from '../../error/app-error';
import { ErrorFacade } from '../../error/error.facade';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionFacade = inject(SessionFacade);
  const errorFacade = inject(ErrorFacade);
  const apiRegex = /(aitarget|aidata)\.(com|tech|me)\/api\//;
  const isJwtUrl =
    req.url.match(apiRegex) && !req.url.includes('api/auth') && !req.url.includes('api/faq');
  const accessToken = sessionFacade.getAccessToken();
  const refreshToken = sessionFacade.getRefreshToken();

  const handleNextRequest = (token: string) =>
    next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    );

  const refreshTokenErrorHandler = (err: HttpErrorResponse | AppError) => {
    if (err instanceof HttpErrorResponse && err.status === 401) {
      sessionFacade.logout();
    } else {
      errorFacade.captureError(err);
    }

    return EMPTY;
  };

  if (!isJwtUrl) {
    return next(req);
  }

  if (accessToken) {
    return handleNextRequest(sessionFacade.getAccessToken()).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return sessionFacade.refreshAccessToken(refreshToken).pipe(
            switchMap((authResult) => handleNextRequest(authResult.token)),
            catchError(refreshTokenErrorHandler)
          );
        }

        errorFacade.captureError(error);
        return EMPTY;
      })
    );
  }

  if (refreshToken) {
    return sessionFacade.refreshAccessToken(refreshToken).pipe(
      switchMap((authResult) => handleNextRequest(authResult.token)),
      catchError(refreshTokenErrorHandler)
    );
  }

  return EMPTY;
};
